import React from 'react'
import image from '../../assets/homepage_prod2.png'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
const BestRated = () => {
    const products = [
        {
            "id": 1,
            "name": "Headphone 1",
            "author": "Charles Duhigg",
            "type": "hardcover",
            "category": "business",
            "image": image
        },
        {
            "id": 2,
            "name": "Headphone 2",
            "author": "Napoleon Hill",
            "type": "hardcover",
            "category": "business",
            "image": image
        },
        {
            "id": 3,
            "name": "Headphone 3",
            "author": "Napoleon Hill",
            "type": "hardcover",
            "category": "business",
            "image": image
        },
        {
            "id": 4,
            "name": "Headphone 4",
            "author": "Napoleon Hill",
            "type": "hardcover",
            "category": "business",
            "image": image
        },
        {
            "id": 5,
            "name": "Headphone 5",
            "author": "Napoleon Hill",
            "type": "hardcover",
            "category": "business",
            "image": image
        },
        {
            "id": 6,
            "name": "Headphone 6",
            "author": "Napoleon Hill",
            "type": "hardcover",
            "category": "business",
            "image": image
        },
    ]
    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        initialSlide: 0,
    }
    return (
        <>
            <Slider {...sliderSettings}>
                {products.map((i,index) => (
                    <div className="item" key={index}>
                        <div className="pro-bx" style={{marginBottom:'40px'}}>
                            <h4>{i.name}</h4>
                            <h3>{i.author}</h3>
                            <div className="prod-img mt-0 p-0">
                                <span className="tag6">Out of stock</span>
                                <img className="img-fluid" src={image} alt="" />
                                <a
                                    href="#"
                                    className="btn-quick"
                                    data-toggle="modal"
                                    data-target="#quickview"
                                >
                                    Quick View
                                </a>
                            </div>
                            <div className="price-prt2">
                                <h5>$245.00</h5>
                            </div>
                            <div className="f-prt">
                                <a href="#" className="wish" data-toggle="tooltip" title="Wishlist">
                                    <i className="fa fa-heart-o" />
                                </a>
                                <a className="btn-cart" href="#">
                                    ADD TO CART
                                </a>
                                <a
                                    href="#"
                                    className="compare"
                                    data-placement="top"
                                    data-toggle="tooltip"
                                    title="Compare"
                                >
                                    <i className="fa fa-refresh" />
                                </a>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
        </>
    )
}

export default BestRated